// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7878ace","732":"63130b47","977":"6bcf3e91"}[chunkId] + ".chunk.js";
};